import classnames from "classnames/bind";
import styles from "./PaymentPlans.module.scss";
import { PaymentPlanOffer } from "./components/PaymentPlanOffer/PaymentPlanOffer";
import { PaymentPlanKlarna } from "./components/PaymentPlanKlarna/PaymentPlanKlarna";
import { PaymentPlansView } from "./getPaymentPlansView";
import { PaymentPlansAnalytics } from "./analytics";
import {
  KLARNA_GENERIC_CLICK,
  KLARNA_INSTALMENT_CLICK,
} from "./monetateEvents";
import { RuntimeConfig } from "@/types/types";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

const cx = classnames.bind(styles);

export type PaymentPlansProps = {
  view: Exclude<PaymentPlansView, { kind: "hidden" }>;
  runtimeConfig?: RuntimeConfig;
  analytics: PaymentPlansAnalytics;
};

export function PaymentPlansUI({
  view,
  runtimeConfig,
  analytics,
}: PaymentPlansProps) {
  const hasPrimaryOffers = view.kind === "offers";

  const showKlarnaPlaceholder = view.kind === "klarnaPlaceholder";
  const klarnaAmountPence = showKlarnaPlaceholder
    ? undefined
    : view.klarnaAmountPence;
  const hasKlarnaOffer =
    showKlarnaPlaceholder || klarnaAmountPence !== undefined;

  return (
    <div className={cx("wrapper", { klarnaOnly: !hasPrimaryOffers })}>
      {hasPrimaryOffers && (
        <div className={styles.header}>
          <h2 className={styles.title}>Payment plans available</h2>
          <p className={styles.subtitle}>Choose a way to pay that suits you</p>
        </div>
      )}
      <div className={styles.offers}>
        {view.kind === "offers" && (
          <PaymentPlanOffer offers={view.primaryOffers} analytics={analytics} />
        )}
        {hasKlarnaOffer && (
          <PaymentPlanKlarna
            klarnaAmountPence={klarnaAmountPence}
            showPlaceholder={showKlarnaPlaceholder}
            runtimeConfig={runtimeConfig}
            onClick={() =>
              dispatchMonetateQEvent(
                showKlarnaPlaceholder
                  ? KLARNA_GENERIC_CLICK
                  : KLARNA_INSTALMENT_CLICK,
              )
            }
          />
        )}
      </div>
    </div>
  );
}
